import React from "react";
import Navbar from "../../components/Navbar";
import "../css/Chat.css";

const AdminChat = () => {
  return (
    <div className="pagina chat-page">
      <Navbar />
      <div className="contenido-principal">
        <div className="chat-container">
          <iframe
            src="https://appempleo.islacristina.org"
            title="Chat Application"
            className="chat-iframe"
            width="100%"
            height="100%"
            frameBorder="0"
            allowFullScreen
          />
        </div>
      </div>
    </div>
  );
};

export default AdminChat;
